const LocationConstants = {
    LOADED: 'LOCATION_LOADED',
    ERROR: 'LOCATION_ERROR',
    LOADING: 'LOCATION_LOADING',
    LOADED_IN_ADMIN: 'LOCATION_LOADED_IN_ADMIN',
    CLEAR: 'LOCATION_CLEAR_LOCATION',
};

export { LocationConstants };
